import { SeverityType } from '@/services/warnings/warningDefinitions';
import { WorkingShift } from '@/types/daily.types';
import { RosterWarningModel, WarningsProps } from '../warnings.types';

const formatTime = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

export const getOverlappingTaskWarnings = (shift: WorkingShift, props: WarningsProps): RosterWarningModel[] => {
  const { strings } = props;
  const { tasks } = shift;

  if (!tasks || tasks.length < 2 || shift.start === undefined || shift.end === undefined) {
    return [];
  }

  const sortedTasks = [...tasks].sort((a, b) => a.start - b.start);

  // After sorting by start, a task overlaps an earlier one if it starts
  // before the latest end seen so far. Touching tasks (end === start) are fine.
  let hasOverlappingTasks = false;
  let latestEnd = sortedTasks[0].end;

  for (let i = 1; i < sortedTasks.length; i++) {
    if (sortedTasks[i].start < latestEnd) {
      hasOverlappingTasks = true;
      break;
    }
    latestEnd = Math.max(latestEnd, sortedTasks[i].end);
  }

  if (!hasOverlappingTasks) {
    return [];
  }

  return [
    {
      severity: SeverityType.CRITICAL,
      name: strings.overlappingTasks.message,
      details: [strings.overlappingTasks.description(formatTime(shift.start), formatTime(shift.end))],
      shiftId: shift.id
    }
  ];
};
